export default "__VITE_ASSET__CWHsluYX__"